import { Link } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { default as TapnFly } from "@/assets/logos/inflow/tap-n-fly.svg"
import { default as McAllenLogoRev } from "@/assets/logos/mcallen-logo-rev.png"
import { default as McAllenLogo } from "@/assets/logos/mcallen-logo.png"
import { IconButton } from "@/globalComponents/atoms/Button"
import { useTheme } from "@/utilities/hooks/useTheme"
import useToggle from "@/utilities/hooks/useToggle"

import Drawer from "./Drawer"

function TopNavigationBar() {
  const { documentThemeMode, scannedArea, uiScheme } = useTheme()
  // const { context } = useMatch({ strict: false })
  const [isOpen, toggleIsOpen] = useToggle()
  const { t } = useTranslation()

  const whiteLabel =
    documentThemeMode === "whiteLabel" ? scannedArea : undefined

  return (
    <>
      <nav className="nav-top-bar" aria-label={t("navigation.mainMenu")}>
        {whiteLabel?.theme[uiScheme].logoURL ? (
          <Link
            to="/qr/$qrLookupID/welcome"
            params={whiteLabel}
            className="nav-top-bar--logo"
          >
            <img src={uiScheme === "light" ? McAllenLogo : McAllenLogoRev} />
          </Link>
        ) : (
          <Link to="/" className="nav-top-bar--logo">
            <TapnFly />
          </Link>
        )}

        <IconButton
          hue="primary"
          presentation="ghost"
          iconName="hamburger"
          aria-label={t("navigation.openMenu")}
          onPress={toggleIsOpen}
        />
      </nav>
      <Drawer isOpen={isOpen} onOpenChange={toggleIsOpen} />
    </>
  )
}
export default TopNavigationBar
